/* Input: 50000 Output: '50,000.00' */
export const formatNumberWithSeparators = (x: number, separator = ',') => {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, separator);
};
